module.exports = __webpack_public_path__ + "static/media/Paris.2890bdc8.jpg";